import React from "react";
import VideoService from "../../packs/services/convertflow/elements/video_service";
import { buildVideoStylesheet } from "./ElementVideoStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";

const ElementVideo = (props) => {
  let element = props.element;
  const classes = style.classes(element, props.builder, props.device);
  const stylesheet = buildVideoStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );
  let videoURL = element.options["video-embed-url"]
    ? element.options["video-embed-url"]
    : "";
  const videoURLFormatted = VideoService.formatEmbedUrl(element.options);
  const videoOptions = VideoService.iframeAllow(element.options);

  return (
    <React.Fragment>
      <div className={classes}>
        {props.builder !== true && videoURLFormatted && (
          <div className="cf-video">
            <iframe
              allowFullScreen="1"
              data-src={videoURLFormatted}
              allow={videoOptions}
              loading="lazy"
              referrerPolicy={
                VideoService.detectProvider(videoURL) === "youtube"
                  ? "strict-origin-when-cross-origin"
                  : undefined
              }
              scrolling="no"
            ></iframe>
          </div>
        )}
        {props.builder == true && (
          <div className="cf-html-placeholder element-content">
            <strong>
              Video: <em>{videoURL ? videoURL : "Video Embed"}</em>
            </strong>
            <br></br>
            Click to edit
          </div>
        )}
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:video`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

const style = {
  classes: (element, builder, device) => {
    let options = element.options;
    let classes = "element-content cf-video-outer ";

    let alignmentClass = "cf-outer-center";

    if (options["cf-alignment"]) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        alignmentClass = "cf-outer-left";
      } else if (options["cf-alignment"].indexOf("center") > -1) {
        alignmentClass = "cf-outer-center";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        alignmentClass = "cf-outer-right";
      }
    }

    classes += " " + alignmentClass;

    return classes;
  },
};

export default ElementVideo;
